import { GET_LEADERBOARD_SUCCESS } from './leaderboard.types';

const initialState = {
  leaderboardList: null
};

export const leaderboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEADERBOARD_SUCCESS:
      return {
        ...state,
        leaderboardList: action.payload,
      }

    default:
      return state;
  }
};